export default __webpack_public_path__ + "static/media/quote-3.00aedeaa.svg";